import { render, staticRenderFns } from "./ReceiverListOfNotReadComp.vue?vue&type=template&id=b7a46e1e&scoped=true"
import script from "./ReceiverListOfNotReadComp.vue?vue&type=script&lang=ts"
export * from "./ReceiverListOfNotReadComp.vue?vue&type=script&lang=ts"
import style0 from "./ReceiverListOfNotReadComp.vue?vue&type=style&index=0&id=b7a46e1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a46e1e",
  null
  
)

export default component.exports